export default "__VITE_ASSET__C4YVS4Tp__"